export type KatapultModel = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string;
    waiting_subject_name: null | string;
    waiting_notes: string;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string;
    prep_notes: string;
    prep_reference_job_id: string;
    prep_reference_job_number_job: string;
    employee_prep_list: Array<KatapultEmployee>;
    percent_prep: number;
    percent_cs: number;
    percent_qc: number;
    qc_notes: string;
    calcspec_notes: string;
    katapult_notes: string;
    pole_total: number;
    department_owner_name: string;
};

export type KatapultMainModel = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string;
    waiting_subject_name: null | string;
    waiting_notes: string;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string;
    prep_notes: string;
    prep_reference_job_id: string;
    prep_reference_job_number_job: string;
    employee_prep_list: Array<KatapultEmployee>;
    percent_prep: number;
    percent_cs: number;
    percent_qc: number;
    qc_notes: string;
    calcspec_notes: string;
    pole_total: number;
    department_owner_name: string;
};

export type GetKatapultListRequest = {
    skip?: string | number;
    take?: string | number;
    id?: string;
};

export type InputAssignKatapult = {
    range_start: number;
    range_end: number;
    employee_id: string;
    employee_name: string;
}

export type AssignUserKatapult = {
    employee_id: string;
    pole_id_list: Array<string>;
}

export type AssignKatapultRequest = {
    id: string;
    date_due: string;
    data: AssignUserKatapult[];
}

export type KatapultEmployee = {
    employee_id: string;
    employee_name: string;
    pole_ids?: string;
    pole_sequences: string;

    pole_id_list?: Array<string>;
    isStatic: boolean;
}

export type KatapultEmployeeGet = {
    employee_id: string;
    employee_name: string;
    pole_sequences: string;
    pole_ids?: string;

    pole_id_list: Array<string>;
    isStatic: boolean;
}

export type InputStatusModel = {
    pause_subject_id?: string;
    notes?: string;
}

export type KatapultWaitingReq = {
    job_id: string;
    waiting_notes: string;
    waiting_subject_id: null | string;
    waiting_by_user: string;
}

export type KatapultCancelReq = {
    job_id: string;
    cancel_notes: string;
    waiting_by_user: string;
}

export type KatapultSummary = {
    employee_id: string;
    employee_name: string;
    total: number;
    date_due: string;
}

export enum KatapultColumnSort {
    project_name,
    department_name,
    kind_job,
    request_date,
    number_id,
    number_job,
    other_number,
    status,
    due_date,
    date_assign,
    req_pole,
}

export enum MainKatapultColumnSort
{
    project_name,
    department_name,
    kind_job,
    request_date,
    number_id,
    number_job,
    status,
    due_date,
    date_assign,
    req_pole
}

export enum SortingEnum {
    Ascending,
    Descending
}

export type GetKatapultWithFilterRequest = {
    project_name?: string;
    department_name?: string;
    kind_job?: string;
    startRequestDate?: string;
    endRequestDate?: string;
    number_id?: string;
    number_job?: string;
    other_number?: string;
    status?: string;
    startDueDate?: string;
    endDueDate?: string;
    startDateAssign?: string;
    endDateAssign?: string;
    req_pole?: number;
    column?: KatapultColumnSort;
    sort?: SortingEnum;
    skip: number;
    take: number;
}

export type GetKatapultMainWithFilterRequest = {
    project_name?: string;
    department_name?: string;
    kind_job?: string;
    startRequestDate?: string;
    endRequestDate?: string;
    number_id?: string;
    number_job?: string;
    status?: string;
    startDueDate?: string;
    endDueDate?: string;
    startDateAssign?: string;
    endDateAssign?: string;
    req_pole?: number;
    column?: MainKatapultColumnSort;
    sort?: SortingEnum;
    employee_id?: string;
    skip: number;
    take: number;
}